<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="Feedback"
    title="Help and Feedback"
    submit-name="Send"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700">
      Do you need help or want to share some feedback? Please send us a message.
      <br />Our Support Team speaks English and Spanish!<br />
    </p>
    <lm-textarea
      ref="messageTextArea"
      label="Type your message"
      :rows="12"
      :maxlength="3000"
      :optional="false"
      :custom-rule="'text'"
      @submit="submitFromInput"
    />
    <span class="text-gray-500 text-xs"
      >If you prefer you can send us an email to
      <a href="mailto:support@landscapemonitor.io"
        >support@landscapemonitor.io</a
      ></span
    >
  </form-modal>
</template>

<script>
import {Modal, AlertMessages, Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmTextarea from '@/components/form/LmTextarea.vue'
import FormHelper from '@/components/form/formHelper'

export default {
  name: 'ModalFeedback',
  components: {
    FormModal,
    LmTextarea
  },
  data() {
    return {
      modalName: Modal.FEEDBACK,
      modalRef: null,
      Events
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.messageTextArea]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        // Call API
        const payload = {
          message: this.$refs.messageTextArea.data
        }
        this.$store
          .dispatch('feedback', payload)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.FEEDBACK_SUCCESS)
      }
    }
  }
}
</script>
